import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { CompanyName } from '@shared/constants/constants';
import { IState } from '@state/state.module';
import { IBrandingStyleResponse } from '../api/dashboard/branding-service/branding-model';
import { StyleService } from '../style/style.service';
import { filter } from 'rxjs';

@Injectable()
export class MetaService {

    customTitle: string = CompanyName;
    currentPageName: string;

    constructor(
        private translation: TranslateService,
        private titleService: Title,
        private store: Store<IState>,
        private styleService: StyleService
    ) {
        this.styleService.brandingStyle$.pipe(
            filter(value => value !== null)
        ).subscribe((brandingStyle: IBrandingStyleResponse) => {

            this.customTitle = brandingStyle.title;

            if (this.currentPageName){
                this.setTitle(this.currentPageName);
            }
         });
    }

    public setTitle(key: string) {
        this.currentPageName = key;
        const extend = this.customTitle ? ' - ' + this.customTitle : '';
        let title = this.translation.instant(key) + extend;

        this.store.select(x => x.app.profile.isSupport)
        .subscribe(isSupport => {
            // Check if authenticated as support account
            if (isSupport) {
                title = '[Support] ' + title;
            }
        });

        this.titleService.setTitle(title);
    }

    public setTitleExternalPage(text: string) {
        this.titleService.setTitle(text + ' - ' + this.customTitle);
    }

}
